import React from "react";
import ATTApplicationsTable from "./ATTApplicationsTable";
import { ShieldCheck, Filter, Search, PieChart, Users } from "lucide-react";

export default function AgentDashboard() {
    return (
        <div className="p-8 space-y-8 animate-in fade-in duration-700">
            {/* Header */}
            <div className="flex flex-col md:flex-row md:items-end justify-between gap-6">
                <div>
                    <div className="flex items-center gap-3 mb-2">
                        <div className="w-12 h-12 rounded-2xl bg-navy-900 flex items-center justify-center text-gold-500 shadow-xl shadow-navy-900/20">
                            <ShieldCheck size={28} />
                        </div>
                        <h1 className="text-3xl font-bold text-navy-900 font-serif">ATT Agent Portal</h1>
                    </div>
                    <p className="text-slate-500 font-medium">Internal review system for Australian Trusted Trader accreditation.</p>
                </div>

                <div className="flex items-center gap-3">
                    <div className="relative">
                        <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" size={16} />
                        <input
                            type="text"
                            placeholder="Search clients..."
                            className="pl-10 pr-4 py-2 bg-white border border-slate-200 rounded-xl text-xs focus:ring-2 focus:ring-navy-900/10 focus:border-navy-900 outline-none w-64 transition-all"
                        />
                    </div>
                    <button className="p-2.5 bg-white border border-slate-200 rounded-xl hover:bg-slate-50 transition-all">
                        <Filter size={18} className="text-navy-900" />
                    </button>
                </div>
            </div>

            {/* Quick Stats */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                <div className="bg-white p-6 rounded-2xl border border-slate-200 shadow-sm flex items-center gap-4 group hover:border-gold-500/30 transition-all">
                    <div className="w-12 h-12 rounded-xl bg-blue-50 flex items-center justify-center text-blue-600 group-hover:scale-110 transition-transform">
                        <PieChart size={24} />
                    </div>
                    <div>
                        <p className="text-[10px] font-bold text-slate-400 uppercase tracking-widest">Pending Review</p>
                        <p className="text-2xl font-bold text-navy-900">Active submissions</p>
                    </div>
                </div>
                <div className="bg-white p-6 rounded-2xl border border-slate-200 shadow-sm flex items-center gap-4 group hover:border-gold-500/30 transition-all">
                    <div className="w-12 h-12 rounded-xl bg-gold-50 flex items-center justify-center text-gold-600 group-hover:scale-110 transition-transform">
                        <ShieldCheck size={24} />
                    </div>
                    <div>
                        <p className="text-[10px] font-bold text-slate-400 uppercase tracking-widest">Audit Score</p>
                        <p className="text-2xl font-bold text-navy-900">ABF Standard</p>
                    </div>
                </div>
                <div className="bg-white p-6 rounded-2xl border border-slate-200 shadow-sm flex items-center gap-4 group hover:border-gold-500/30 transition-all">
                    <div className="w-12 h-12 rounded-xl bg-emerald-50 flex items-center justify-center text-emerald-600 group-hover:scale-110 transition-transform">
                        <Users size={24} />
                    </div>
                    <div>
                        <p className="text-[10px] font-bold text-slate-400 uppercase tracking-widest">Managed Clients</p>
                        <p className="text-2xl font-bold text-navy-900">Portfolio view</p>
                    </div>
                </div>
            </div>

            {/* Table Section */}
            <div className="space-y-4">
                <div className="flex justify-between items-center px-2">
                    <h2 className="text-lg font-bold text-navy-900">Applications Portfolio</h2>
                    <span className="text-[10px] font-bold text-slate-400 uppercase tracking-widest italic">Live from Firestore</span>
                </div>
                <ATTApplicationsTable />
            </div>
        </div>
    );
}
